{
  "accountTitle": "Account Title",
  "accountWalletName": "Account / Wallet Name",
  "approvedBalance": "Approved Balance",
  "approvedRewards": "Approved Rewards",
  "availableBalance": "Available Balance",
  "balance": "Balance",
  "bank": "Bank",
  "bnbWallet": "BNB Wallet",
  "buyBnbUsdt": "Buy BNB / USDT",
  "buyBnbUsdtText": "Purchase BNB or USDT directly to fund your wallet.",
  "buyCryptoSubtitle": "Buy crypto safely and fund your EXALT wallet.",
  "buyExaltCoin": "Buy EXALT Coin",
  "buyExaltOnPancake": "Buy EXALT on PancakeSwap",
  "connectedWallet": "Connected Wallet",
  "copied": "Copied",
  "copyAddress": "Copy Address",
  "copyContract": "Copy Contract",
  "copyExaltContract": "Copy EXALT Contract Address",
  "copyFailed": "Copy failed",
  "copyIban": "Copy IBAN",
  "copyNumber": "Copy Number",
  "deposit": "Deposit",
  "depositAddress": "Deposit Address",
  "depositFailed": "Deposit failed.",
  "depositRequest": "Deposit Request",
  "depositRequiredFields": "Name, account/wallet and amount are required.",
  "depositSubmittedSuccessfully": "Deposit request submitted successfully.",
  "estimatedExchangeWalletValue": "Estimated Exchange Wallet Value",
  "exaltContractCopied": "EXALT contract address copied.",
  "exaltWallet": "EXALT Wallet",
  "fakeSupportReminder": "Beware of fake support agents. Exalt Exchange staff will never ask for your password or private keys.",
  "loadingWallet": "Loading wallet...",
  "lockedBalance": "Locked Balance",
  "pendingRewards": "Pending Rewards",
  "readyTradingWithdrawal": "Ready for trading or withdrawal.",
  "refreshBalance": "Refresh Balance",
  "securityAdminApproval": "Admin approval required before wallet credit.",
  "securityBackendApproval": "Deposits and withdrawals are protected through backend approval.",
  "securityLicensedGateways": "Payments are processed through licensed gateways.",
  "securityNoAutoRelease": "No automatic token release without verification.",
  "securityReminder": "Security Reminder",
  "securitySystem": "Security System",
  "securityWalletVerification": "Wallet ownership verification protects your assets.",
  "sellSwapBack": "Sell / Swap Back",
  "sellSwapBackText": "Swap your EXALT back to BNB or USDT at any time.",
  "serverError": "Server error.",
  "sessionExpired": "Session expired. Please login again.",
  "step1": "Step 1",
  "step2": "Step 2",
  "step3": "Step 3",
  "submitDeposit": "Submit Deposit",
  "submitWithdrawal": "Submit Withdrawal",
  "swapToExaltText": "Swap your BNB or USDT for EXALT.",
  "totalAssets": "Total Assets",
  "totalPortfolioValue": "Total Portfolio Value",
  "transactionHashReference": "Transaction Hash / Reference ID",
  "transfer": "Transfer",
  "usdtWallet": "USDT Wallet",
  "useBscReminder": "Always use the BNB Smart Chain (BEP-20) network.",
  "verifyContractReminder": "Always verify the official contract address before trading.",
  "waitingAdminApproval": "Waiting for admin approval.",
  "wallet": "Wallet",
  "walletAddress": "Wallet Address",
  "walletBankIbanPlaceholder": "Wallet Address / JazzCash / Easypaisa / Bank Account / IBAN",
  "walletNotConnected": "Wallet not connected",
  "walletStatus": "Wallet Status",
  "walletsSubtitle": "Manage crypto wallet, deposits, withdrawals and payment requests.",
  "walletsTitle": "Wallets",
  "withdraw": "Withdraw",
  "withdrawRequiredFields": "Amount, account name and wallet/account number are required.",
  "withdrawalFailed": "Withdrawal failed.",
  "withdrawalRequest": "Withdrawal Request",
  "withdrawalSubmittedSuccessfully": "Withdrawal request submitted successfully.",
  "yourName": "Your Name"
}